/***
 *
 *   VERTICAL NAV
 *   Primary desktop navigation used inside the main app.
 *
 *   DOCS
 *   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/nav
 *
 *   PROPS
 *   items:[{ label: string, link: string, icon: string }] (array, required)
 *
 **********/

import { NavLink } from "react-router-dom";
import {
  Logo,
  Button,
  Icon,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  cn,
} from "components/lib";

export function VerticalNav({ items }) {
  const userPermission_local=JSON.parse(localStorage.getItem('user'))?.permission;
  function renderItem(item) {
    return (
      <Tooltip key={item.label}>
        <TooltipTrigger asChild>
          <div style={{ display: item?.notAllowed?.includes(userPermission_local) ? "none" : "block" }}>
            {item.link ? (
              <NavLink to={item.link}>
                {({ isActive }) => (
                  <div
                    className={cn(
                      "group flex items-center rounded-lg gap-3 py-3 px-3 text-white/70 font-light tracking-wide nav-glass-hover dark:nav-glass-hover-dark transition-all duration-200",
                      { 
                        "text-white bg-white/10 backdrop-blur-md border border-white/20 shadow-lg": isActive 
                      }
                    )}
                  >
                    {!item.customIcon ? (
                      <Icon
                        name={item.icon}
                        size={18}
                        className="relative -top-[1px] text-current"
                      />
                    ) : (
                      <span className="relative -top-[1px] inline-flex">
                        <item.icon color={isActive ? "white" : "rgba(255,255,255,0.7)"} />
                      </span>
                    )}
                    <span className="font-light">{item.label}</span>
                  </div>
                )}
              </NavLink>
            ) : (
              <div
                onClick={item.action}
                className="group flex items-center rounded-lg gap-3 py-3 px-3 text-white/70 font-light tracking-wide nav-glass-hover dark:nav-glass-hover-dark transition-all duration-200 cursor-pointer"
              >
                {!item.customIcon ? (
                  <Icon
                    name={item.icon}
                    size={18}
                    className="relative -top-[1px] text-current"
                  />
                ) : (
                  <span className="relative -top-[1px] inline-flex">
                    <item.icon color="rgba(255,255,255,0.7)" />
                  </span>
                )}
                <span className="font-light">{item.label}</span>
              </div>
            )}
          </div>
        </TooltipTrigger>
      </Tooltip>
    );
  }

  return (
    <aside className="fixed pt-6 inset-y-0 left-0 z-20 hidden w-[246px] flex-col sm:flex glass-nav dark:glass-nav-dark">
      <div className="px-6 mb-8 fade-in">
        <Logo
          mark
          className="w-[102px] h-[33px] brightness-0 invert"
          text="Atlas"
        />
      </div>

      {/* top items */}
      <nav className="px-6 py-2 slide-up" style={{animationDelay: '0.1s'}}>
        {items?.length > 0 &&
          items.map((item) => {
            return item.position === "top" ? renderItem(item) : false;
          })}
      </nav>

      {/* bottom items */}
      <nav className={cn("px-6 py-2 slide-up", "mt-auto mb-6")} style={{animationDelay: '0.2s'}}>
        {items?.length > 0 &&
          items.map((item) => {
            return item.position === "bottom" ? renderItem(item) : false;
          })}
      </nav>
    </aside>
  );
}
